import axios from 'axios'
import vue from 'vue'
import store from '~/store'
import { GLOBAL_MODULE_TYPE_GARDEROBY, GLOBAL_MODULE_TYPE_SZAFY, globalType } from '../../resource/ModuleTypes'
// state
export const state = {
  doors: []
}

// getters
export const getters = {
  doors: state => {
    return state.doors
  },

  doorsCollection: (state) => {
    let comb = store.getters['modules/modulesWidth'] / 50

    let sortDoors = []
    let sort = []

    for (var i = comb; i > 0; i--) {
      sort = state.doors.filter(door => parseInt(door.position) === parseInt(i))
      if (sort.length) sortDoors.push(sort)
    }
    return sortDoors
  },

  doorsIdentifier: (state) => (getters) => {
    let doorIdenfier = state.doors.find(door => door.id === parseInt(getters)).identifier
    return state.doors.filter(door => door.identifier === parseInt(doorIdenfier))
  },

  doorHandle: (state) => {
    let moduleCombination = store.getters['modules/moduleChooseCombination']
    let doorHandle = []
    for (var i = 0; i < moduleCombination.length; i++) {
      doorHandle.push(moduleCombination[i])
      if (moduleCombination[i] === 100) doorHandle.push(50)
    }

    return doorHandle
  }
}

// mutations
export const mutations = {
  FETCH_DOORS (state, { doors }) {
    state.doors = doors
  },

  SET_DOOR (state, door) {
    state.doors.push(door)
  },

  UPDATE_DOOR (state, door) {
    var foundIndex = state.doors.findIndex(x => x.id === parseInt(door.id))

    vue.set(state.doors, foundIndex, door)
  },

  DELETE_DOOR (state, id) {
    var foundIndex = state.doors.findIndex(x => x.id === parseInt(id))

    state.doors.splice(foundIndex, 1)
  },

  setDoorAccessories (state, payload) {
    var foundIndexModule = getDoorIndex(payload)

    state.doors[foundIndexModule].accessories.push(payload.accessory)
  },

  updateDoorAccessories (state, payload) {
    var foundIndexDoor = getDoorIndex(payload)

    var foundIndexAccessory = getAccessoryIndexInDoors(payload)

    state.doors[foundIndexDoor].accessories[foundIndexAccessory].pivot.quantity = payload.quantity
  },

  deleteDoorAccessories (state, payload) {
    var foundIndexDoor = getDoorIndex(payload)

    var foundIndexAccessory = getAccessoryIndexInDoors(payload)

    state.doors[foundIndexDoor].accessories.splice(foundIndexAccessory, 1)
  }
}

// actions
export const actions = {
  /**
   * Fetch all modules
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllDoors ({ commit }) {
    try {
      var szafy = []

      var garderoby = []

      await indexDoors(GLOBAL_MODULE_TYPE_SZAFY).then(request => {
        szafy = request
      })

      await indexDoors(GLOBAL_MODULE_TYPE_GARDEROBY).then(request => {
        garderoby = request
      })

      let data = szafy.concat(garderoby)

      commit('FETCH_DOORS', { doors: data })
    } catch (e) {
    }
  },

  /**
   * Fetch module by type
   *
   * @param commit
   * @param payload
   */
  fetchDoorsByType ({ commit }, payload) {
    axios.get('/api/door', {
      params: {
        type_door: globalType(payload)
      }
    }).then(({ data }) => {
      commit('FETCH_DOORS', { doors: data })
    })
  },

  fetchDoors ({ commit }) {
    axios.get('/api/door').then(({ data }) => {
      commit('FETCH_DOORS', { doors: data })
    })
  },

  async setDoor ({ commit }, door) {
    try {
      commit('SET_DOOR', door)
    } catch (e) {
    }
  },

  async updateDoor ({ commit }, door) {
    try {
      commit('UPDATE_DOOR', door)
    } catch (e) {
    }
  },

  async deleteDoor ({ commit }, id) {
    try {
      commit('DELETE_DOOR', id)
    } catch (e) {
    }
  },

  async setDoorAccessories ({ commit }, payload) {
    try {
      commit('setDoorAccessories', payload)
    } catch (e) {
    }
  },

  async updateDoorAccessories ({ commit }, payload) {
    try {
      commit('updateDoorAccessories', payload)
    } catch (e) {
    }
  },

  async deleteDoorAccessories ({ commit }, payload) {
    try {
      commit('deleteDoorAccessories', payload)
    } catch (e) {
    }
  }
}

function getDoorIndex (payload) {
  return state.doors.findIndex(x => x.id === parseInt(payload.door.id))
}

function getAccessoryIndexInDoors (payload) {
  return state.doors[getDoorIndex(payload)].accessories.findIndex(x => x.id === parseInt(payload.accessory.id))
}

/**
 * Index modules help function by fetch all
 *
 * @param type
 * @returns {Promise<void>}
 */
async function indexDoors (type) {
  const { data } = await axios.get('/api/door', {
    params: {
      type_door: type
    }
  })

  return data
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/doors.js